import dayjs from 'dayjs';
import { EComplaintStatus } from '@svitlofour/types';

import { useGetComplaintCasesQuery } from 'store';

// openTotal рахує всі відкриті справи незалежно від періоду й фільтрів; період
// обов'язковий для API, тож передаємо широкий, а самі справи не потрібні (limit 1).
const REQUEST = {
  fromDate: dayjs().year(2023).startOf('year').toISOString(),
  toDate: dayjs().add(1, 'year').toISOString(),
  page: 1,
  limit: 1,
  status: EComplaintStatus.NEW,
};

export const useOpenComplaintsCount = (skip = false) => {
  const { data } = useGetComplaintCasesQuery(REQUEST, {
    skip,
    pollingInterval: 60_000,
  });

  return data?.openTotal ?? 0;
};
